import { SVGFC } from '@repo/toolkit/types'

const CheckMarkFourIcon: SVGFC = ({ color, ...props }) => {
  return (
    <svg
      width="22"
      height="23"
      viewBox="0 0 22 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_15969_25990)">
        <path
          d="M11 1.5C5.48154 1.5 1 5.98154 1 11.5C1 17.0185 5.48154 21.5 11 21.5C16.5185 21.5 21 17.0185 21 11.5C21 5.98154 16.5185 1.5 11 1.5ZM11 2.27077C16.1023 2.27077 20.2308 6.39769 20.2308 11.5C20.2308 16.6023 16.1023 20.7308 11 20.7308C5.89769 20.7308 1.76923 16.6023 1.76923 11.5C1.76923 6.39769 5.89769 2.27077 11 2.27077ZM11.0015 6.49692C10.3445 6.49621 9.69373 6.62537 9.08674 6.87698C8.47975 7.12859 7.92848 7.4977 7.46462 7.96308C6.99959 8.42708 6.63065 8.97826 6.37892 9.58504C6.12719 10.1918 5.99761 10.8423 5.99761 11.4992C5.99761 12.1562 6.12719 12.8066 6.37892 13.4134C6.63065 14.0202 6.99959 14.5714 7.46462 15.0354C7.92862 15.5004 8.4798 15.8694 9.08658 16.1211C9.69336 16.3728 10.3438 16.5024 11.0008 16.5024C11.6577 16.5024 12.3082 16.3728 12.915 16.1211C13.5217 15.8694 14.0729 15.5004 14.5369 15.0354C15.002 14.5714 15.3709 14.0202 15.6226 13.4134C15.8744 12.8066 16.0039 12.1562 16.0039 11.4992C16.0039 10.8423 15.8744 10.1918 15.6226 9.58504C15.3709 8.97826 15.002 8.42708 14.5369 7.96308C14.0733 7.49775 13.5223 7.12866 12.9156 6.87704C12.3089 6.62542 11.6584 6.49624 11.0015 6.49692ZM13.2785 9.96H13.3185C13.6385 9.96462 13.7977 10.4677 13.5392 10.6554L10.4623 12.9631C10.3873 13.0159 10.2963 13.0412 10.2047 13.0346C10.1131 13.028 10.0267 12.99 9.96 12.9269L8.42154 11.3885C8.12769 11.1062 8.68308 10.55 8.96538 10.8446L10.2685 12.1477L13.0777 10.04C13.1361 9.99507 13.2059 9.96736 13.2792 9.96H13.2785Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_15969_25990">
          <rect width="20" height="20" fill={color} transform="translate(1 1.5)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default CheckMarkFourIcon
